import api from "@helpers/api";
import { useEffect, useState } from "react";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/vendors/by/nature`;

export const useSupplier = () => {
  const [resData, setResData] = useState<any>([]);

  const moduleName = localStorage.getItem("module");

  const vendorType = moduleName === "ITS" ? "ICT" : "NOT_ICT";

  const fetchSupplierData = async (vendorType: string) => {
    try {
      const res = await api.get(`${apiEndPoint}/${vendorType}`, {
        params: {
          page: 1,
          size: 1000000,
          search: "",
        },
      });

      setResData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSupplierData(vendorType);
  }, [vendorType]);

  return {
    resData,
  };
};
